import React from 'react'
import {Svg} from '@modifi/ui'

export default ({...props}) => (
  <Svg width="469" height="277" viewBox="0 0 469 277" {...props}>
    <g fill="none" fillRule="evenodd">
      <path fill="#FFF" d="M0 0h469v277H0z" />
      <g transform="translate(57 104)">
        <path
          fill="#fff"
          d="M0 70V0h70v70H0zm44.374-55.388L35 41.045l-9.374-26.433h-12.07v40.776h9.587v-19.09l6.77 19.09h10.174l6.77-19.09v19.09h9.587V14.612h-12.07z"
        />
        <path
          fill="#51A2DA"
          d="M0 70V0h70v70H0zm44.374-55.388L35 41.045l-9.374-26.433h-12.07v40.776h9.587v-19.09l6.77 19.09h10.174l6.77-19.09v19.09h9.587V14.612h-12.07z"
        />
      </g>
      <path
        fill="#A2D65F"
        d="M187.63 140.386H163v-4.341h24.984l-6.002-7.296 2.79-2.749 8.748 10.632c.64.78.64 1.96 0 2.736L184.772 150l-2.79-2.749 5.647-6.865z"
      />
      <path
        fill="#A0D3F9"
        d="M404.16 66.681h22.673V64H404.16zM252.617 104.816h22.672v-2.68h-22.672z"
      />
      <path fill="#C0E7FF" d="M246.054 102.433h22.672v-2.681h-22.672z" />
      <path
        fill="#A0D3F9"
        d="M451.294 91.41h15.513v-2.682h-15.513zM238 178.683v97.741h65.032V135.801z"
      />
      <path
        fill="#FFF"
        d="M284.835 198.962h18.496v-3.873h-18.496zM277.676 198.962h4.176v-3.873h-4.176zM270.815 184.364h4.176v-3.873h-4.176z"
      />
      <path fill="#CDEAFC" d="M270.815 191.514h4.176v-3.873h-4.176z" />
      <path
        fill="#FFF"
        d="M270.815 198.962h4.176v-3.873h-4.176zM284.835 184.364h18.496v-3.873h-18.496zM277.676 184.364h4.176v-3.873h-4.176zM284.835 191.514h18.496v-3.873h-18.496z"
      />
      <path
        fill="#CDEAFC"
        d="M277.676 191.514h4.176v-3.873h-4.176zM260.592 236.345v-3.419h14.262v8.039h5.507v17.584h-17.658v-8.004H248.44v-14.2z"
      />
      <path
        transform="translate(264.848 241.566)"
        stroke="#1251A0"
        strokeWidth=".953"
        d="M.504.108v34.75"
      />
      <path
        stroke="#1251A0"
        strokeWidth=".953"
        d="M264.848 248.717h7.16v4.17h-2.971M265.445 244.099h-6.265"
      />
      <path fill="#A0D3F9" d="M402.968 276.424H468v-97.74L402.968 135.8z" />
      <path fill="#A0D3F9" d="M299.453 276.424H405.95V86.344H299.453z" />
      <path
        fill="#FFF"
        d="M324.213 114.648h25.655v-3.873h-25.655zM356.132 114.648h25.655v-3.873h-25.655zM324.213 122.096h25.655v-3.873h-25.655z"
      />
      <path fill="#D2EEFF" d="M356.132 122.096h25.655v-3.873h-25.655z" />
      <path
        fill="#FFF"
        d="M324.213 129.545h25.655v-3.873h-25.655zM356.132 129.545h25.655v-3.873h-25.655z"
      />
      <path fill="#D2EEFF" d="M324.213 136.993h25.655v-3.873h-25.655z" />
      <path
        fill="#FFF"
        d="M402.67 198.962h18.495v-3.873h-18.496zM424.148 198.962h4.176v-3.873h-4.176zM431.01 184.364h4.175v-3.873h-4.176z"
      />
      <path fill="#CDEAFC" d="M431.01 191.514h4.175v-3.873h-4.176z" />
      <path fill="#FFF" d="M431.01 198.962h4.175v-3.873h-4.176z" />
      <path fill="#CDEAFC" d="M402.67 184.364h18.495v-3.873h-18.496z" />
      <path
        fill="#FFF"
        d="M424.148 184.364h4.176v-3.873h-4.176zM402.67 191.514h18.495v-3.873h-18.496z"
      />
      <path fill="#CDEAFC" d="M424.148 191.514h4.176v-3.873h-4.176z" />
      <path
        fill="#FFF"
        d="M356.132 136.993h25.655v-3.873h-25.655zM324.213 144.441h25.655v-3.873h-25.655zM356.132 144.441h25.655v-3.873h-25.655z"
      />
      <path fill="#1251A0" d="M288.415 276.424H416.69v-92.06H288.415z" />
      <path fill="#1251A0" d="M288.415 184.364H416.69v-28.9H288.415z" />
      <path fill="#50A1DA" d="M297.663 167.382h109.78v-6.257h-109.78z" />
      <path fill="#EAEAEA" d="M298.26 276.424h109.48v-92.06H298.26z" />
      <path
        fill="#1251A0"
        d="M306.612 216.242h93.074v-3.277h-93.074zM306.612 248.12h93.074v-3.276h-93.074zM306.612 276.424h93.074v-3.575h-93.074z"
      />
      <path fill="#50A1DA" d="M303.032 276.424h4.475v-96.231h-4.475z" />
      <path
        fill="#1251A0"
        d="M304.524 188.833h2.088v-6.853h-2.088zM304.524 197.473h2.088v-6.853h-2.088zM304.524 206.113h2.088v-6.853h-2.088zM304.524 214.455h2.088v-6.853h-2.088zM304.524 223.095h2.088v-6.853h-2.088zM304.524 231.437h2.088v-6.853h-2.088zM304.524 240.077h2.088v-6.853h-2.088zM304.524 248.419h2.088v-6.853h-2.088zM304.524 256.76h2.088v-6.851h-2.088zM304.524 265.4h2.088v-6.851h-2.088zM304.524 273.743h2.088v-6.852h-2.088z"
      />
      <path fill="#50A1DA" d="M398.493 276.424h4.475v-96.231h-4.475z" />
      <path
        fill="#1251A0"
        d="M399.388 188.833h2.088v-6.853h-2.088zM399.388 197.473h2.088v-6.853h-2.088zM399.388 206.113h2.088v-6.853h-2.088zM399.388 214.455h2.088v-6.853h-2.088zM399.388 223.095h2.088v-6.853h-2.088zM399.388 231.437h2.088v-6.853h-2.088zM399.388 240.077h2.088v-6.853h-2.088zM399.388 248.419h2.088v-6.853h-2.088zM399.388 256.76h2.088v-6.851h-2.088zM399.388 265.4h2.088v-6.851h-2.088zM399.388 273.743h2.088v-6.852h-2.088z"
      />
      <path fill="#50A1DA" d="M364.187 244.844h17.004v-14.599h-17.004z" />
      <path fill="#CDEAFC" d="M346.885 244.844h17.302v-14.599h-17.302z" />
      <path fill="#1251A0" d="M329.88 244.844h17.005v-14.599H329.88z" />
      <path
        fill="#DDD"
        d="M381.19 244.844h12.828v-10.726h-12.827zM312.578 244.844h17.303v-10.726h-17.303zM329.88 230.245h13.425v-9.236H329.88zM359.712 272.85h22.075v-18.77h-22.075z"
      />
      <path fill="#1251A0" d="M337.04 272.85h22.672v-18.77H337.04z" />
      <path fill="#50A1DA" d="M314.667 272.85h22.373v-14.301h-22.373z" />
      <path fill="#CDEAFC" d="M381.787 272.85h10.143v-14.6h-10.143z" />
      <path fill="#50A1DA" d="M359.414 231.139h13.424v-9.236h-13.424z" />
      <path fill="#1251A0" d="M345.99 231.139h13.424v-7.15H345.99z" />
      <path fill="#DDD" d="M372.241 212.667h19.987v-15.79h-19.987z" />
      <path fill="#CDEAFC" d="M352.254 212.965h19.987v-15.79h-19.987z" />
      <path fill="#1251A0" d="M332.267 212.965h19.987v-15.79h-19.987z" />
      <path fill="#50A1DA" d="M312.578 212.965h20.286v-12.513h-20.286z" />
      <path fill="#DDD" d="M357.027 197.175h18.794V179h-18.794z" />
      <path fill="#50A1DA" d="M376.12 197.175h15.213V181.98H376.12z" />
      <path
        fill="#FFF"
        d="M358.817 182.278h4.475v-2.085h-4.475zM360.905 183.768h2.387v-1.192h-2.387z"
      />
      <path
        fill="#50A1DA"
        d="M359.458 181.98h.21v-1.49h-.21zM362.715 181.98h.258v-1.49h-.258zM362.464 181.98h.164v-1.49h-.164zM362.18 181.98h.135v-1.49h-.135zM361.916 181.98h.067v-1.49h-.067zM360.379 181.98h.158v-1.49h-.158zM359.809 181.98h.105v-1.49h-.105zM360.107 181.98h.105v-1.49h-.105zM360.703 181.98h.106v-1.49h-.106zM361.002 181.98h.105v-1.49h-.105zM361.274 181.98h.158v-1.49h-.158zM361.598 181.98h.106v-1.49h-.106z"
      />
      <path fill="#50A1DA" d="M361.897 181.98h.105v-1.49h-.105z" />
      <path fill="#50A1DA" d="M361.897 181.98h.105v-1.49h-.105z" />
      <path fill="#50A1DA" d="M288.415 184.364H416.69v-6.257H288.415z" />
      <path fill="#C0E7FF" d="M221 138h18v-3h-18z" />
    </g>
  </Svg>
)
